import createLucideIcon from '../createLucideIcon';

const Ban = createLucideIcon('Ban', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['line', { x1: '4.93', x2: '19.07', y1: '4.93', y2: '19.07', key: '1thnyu' }],
]);

export default Ban;
